export default {
  JZSPLAJ: { location: "Jumeirah Zabeel Saray", name: "Pool and Beach" },
  AQPOOL: { location: "Madinat Jumeirah", name: "Al Qasr Pool" },
  BAAPDR: { location: "Burj Al Arab", name: "In-Room Dining" },
  SALCABANA: { location: "Burj Al Arab", name: "SAL Cabana" },
  BAASCAP: { location: "Burj Al Arab", name: "SAL Pool" },
  DAMPDR: { location: "Dar Al Masyaf", name: "In-Room Dining" },
  DAMMINIBAR: { location: "Dar Al Masyaf", name: "Minibar" },
  DAMPOOL: { location: "Dar Al Masyaf", name: "Pool" },
  ALNPDR: { location: "Jumeirah Al Naseem", name: "In-Room Dining" },
  ALNMINIB: { location: "Jumeirah Al Naseem", name: "Minibar" },
  ALNPOOL: { location: "Jumeirah Al Naseem", name: "Pool" },
  SUGARMASH: { location: "Jumeirah Al Naseem", name: "Sugarmash" },
  SUMSALT: { location: "Jumeirah Al Naseem", name: "Summersalt" },
  JBHEXEP: { location: "Jumeirah Beach Hotel", name: "Pool" },
  JBHFMP: { location: "Jumeirah Beach Hotel", name: "Pool" },
  JBHOCNB: { location: "Jumeirah Beach Hotel", name: "Pool" },
  JBHPDR: { location: "Jumeirah Beach Hotel", name: "In-Room Dining" },
  JBHPOOL: { location: "Jumeirah Beach Hotel", name: "Pool" },
  JCTPDR: { location: "The Carlton Tower Jumeirah", name: "In-Room Dining" },
  JETPDR: { location: "Jumeirah Emirates Towers", name: "In-Room Dining" },
  JETPOOL: { location: "Jumeirah Emirates Towers", name: "Pool" },
  JETOFF: { location: "Jumeirah Emirates Towers", name: "Offices" },
  JGBPDR: { location: "Jumeirah Gulf of Bahrain", name: "In-Room Dining" },
  JGBOAB: { location: "Jumeirah Gulf of Bahrain", name: "Obab Al Bahar" },
  JGBMARI: { location: "Jumeirah Gulf of Bahrain", name: "Due Mari" },
  JGBMAF: { location: "Jumeirah Gulf of Bahrain", name: "Majlis Al Fijiri" },
  JGBSAMA: { location: "Jumeirah Gulf of Bahrain", name: "Al Sama" },
  JGBMARI1: { location: "Jumeirah Gulf of Bahrain", name: "Pool" },
  JGBOSL: { location: "Jumeirah Gulf of Bahrain", name: "Ousoul" },
  JLHPDR: { location: "Jumeirah Lowndes Hotel", name: "In-Room Dining" },
  JLWTCPDR: {
    location: "Jumeirah Living World Trade Center",
    name: "In-Room Dining",
  },
  JLWTCPOOL: { location: "Jumeirah Living World Trade Center", name: "Pool" },
  JLWTCCL: {
    location: "Jumeirah Living World Trade Center",
    name: "The Club Lounge",
  },
  JMHIVD: { location: "Jumeirah Maldives Hotel", name: "In Villa Dining" },
  JMHSHMRS: { location: "Jumeirah Maldives Hotel", name: "Shimmers" },
  JMBPDR: { location: "Jumeirah Messilah Beach", name: "In-Room Dining" },
  JMBMNT: { location: "Jumeirah Messilah Beach", name: "Mint" },
  JMBOLO: { location: "Jumeirah Messilah Beach", name: "Olio" },
  JMBPPR: { location: "Jumeirah Messilah Beach", name: "Pepper" },
  JPSPDR: { location: "Jumeirah Port Soller", name: "In-Room Dining" },
  JPSINFY: { location: "Jumeirah Port Soller", name: "Infinity Pool" },
  JPSSTP: { location: "Jumeirah Port Soller", name: "Sa Talaia" },
  PAITHAI: { location: "Jumeirah Al Qasr", name: "Pai Thai" },
  TNHMJ: { location: "Madinat Jumeirah", name: "The Noodle House" },
  TNHJBR: { location: "Jumeirah Beach Residence", name: "The Noodle House" },
  TNHNM: { location: "Nakheel Mall", name: "The Noodle House" },
  JRTRA: { location: "Madinat Jumeirah", name: "Trattoria" },
  JSIPOOL: { location: "Jumeirah Sadiyat Island", name: "Pool Bar" },
  JZSPDR: { location: "Jumeirah Zabeel Saray", name: "In-Room Dining" },
  // JZSPLAJ: { location: "Jumeirah Zabeel Saray", name: "Zenzi" },
  MASBEACH: { location: "Mina A' Salam", name: "Beach" },
  MASPDR: { location: "Mina A' Salam", name: "In Room Dining" },
  MASPOOL: { location: "Mina A' Salam", name: "Pool" },
  MASSHIM: { location: "Mina A' Salam", name: "Shimmers" },
  AQFAYRLN: { location: "Jumeirah Al Qasr", name: "Al Fayrooz Lounge" },
  AQPDR: { location: "Jumeirah Al Qasr", name: "In-Room Dining" },
  // AQPOOL: { location: "Jumeirah Al Qasr", name: "Pool" },
  AQBEACH: { location: "Jumeirah Al Qasr", name: "Beach" },
  AQMINIBAR: { location: "Jumeirah Al Qasr", name: "Minibar" },
  MLKPDR: { location: "Malakiya Villas Jumeirah", name: "In-Room Dining" },
  MLKMINIBAR: { location: "Malakiya Villas Jumeirah", name: "Minibar" },
  AQHIDE: { location: "Jumeirah Al Qasr", name: "The Hide" },
  JMUZUKA: { location: "Jumeiah Muscat Bay", name: "Zuka" },
  ZHGPDR: { location: "Zabeel House The Greens", name: "In-Room Dining" },
  ZHGPOOL: { location: "Zabeel House The Greens", name: "Pool" },
};
